export default __webpack_public_path__ + "media/flavours/glitch/images/elephant_ui_working-8d131ca68f598cb545a64ac0563199d1.svg";